var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.33454C3 4.94064 4.94064 3 7.33454 3C9.72844 3 11.6691 4.94064 11.6691 7.33454C11.6691 8.49426 11.2136 9.5476 10.4718 10.3255C10.4453 10.3471 10.4196 10.3702 10.3949 10.3949C10.3702 10.4197 10.347 10.4453 10.3254 10.4719C9.54756 11.2136 8.49423 11.6691 7.33454 11.6691C4.94064 11.6691 3 9.72844 3 7.33454ZM11.0507 12.465C10.0069 13.2224 8.72287 13.6691 7.33454 13.6691C3.83607 13.6691 1 10.833 1 7.33454C1 3.83607 3.83607 1 7.33454 1C10.833 1 13.6691 3.83607 13.6691 7.33454C13.6691 8.7229 13.2224 10.0069 12.465 11.0508L14.7097 13.2956C15.1003 13.6861 15.1003 14.3193 14.7097 14.7098C14.3192 15.1003 13.6861 15.1003 13.2955 14.7098L11.0507 12.465Z",
    fill: "url(#paint0_linear_72_2430)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_2430",
    x1: 5.81975,
    y1: 11.502,
    x2: 15.4297,
    y2: 10.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.5427ef36802702e1354ec2020f98e9ab.svg";
export { ForwardRef as ReactComponent };